
define('jst!shared/generic_warning',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="warning">\n  <p><%=message%></p>\n</div>');
 });

